module.exports = __webpack_public_path__ + "7aa7aab15a30318fcab7bc6dd36c83f8.svg";